import React from "react";
import { Box, Button, Paper, Typography, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TOKENS } from "./tokens";
import {cookiesAcceptAll, cookiesOpenSettings, cookiesRejectNonEssential} from "../../../actions/cookies/actions";
import Immutable from "immutable";
import {useTranslation} from "react-i18next";
import {FOOTER} from "../../../locales/components/namespaces";


export default function CookieBanner() {
    const { t} = useTranslation(FOOTER);
    const dispatch = useDispatch();
    const consent = useSelector((s) => s.cookies?.get("consent"));
    const consentJS = Immutable.Map.isMap(consent) ? consent.toJS() : consent;

    if (consentJS) return null;

    return (
        <Box sx={{ position: "fixed", left: 16, bottom: 16, zIndex: 1400, width: { xs: "calc(100% - 32px)", sm: 500 } }}>
            <Paper sx={{
                p: 2,
                borderRadius: 3,
                //border: `1px solid ${TOKENS.black}`,
                bgcolor: TOKENS.white
            }}>
                <Typography sx={{ fontFamily: "Zen Maru Gothic", fontWeight: 900, fontSize: 18, textTransform: "uppercase", color: TOKENS.black, mb: 1 }}>
                    {t('We use cookies!')}
                </Typography>

                <Typography sx={{ fontFamily: "Roboto Condensed", fontSize: 14, lineHeight: "120%", color: TOKENS.black, mb: 2 }}>
                    {t('We use cookies to improve your experience. You can accept all, reject non-essential, or customize preferences.')}
                </Typography>

                <Stack direction="row" spacing={1} justifyContent="flex-start" flexWrap="wrap" gap={1}>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(cookiesAcceptAll())}
                        sx={{ bgcolor: TOKENS.magenta, borderRadius: 120, px: 3, fontFamily: "Zen Maru Gothic", fontWeight: 900 }}
                    >
                        {t('Accept all')}
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => dispatch(cookiesOpenSettings())}
                        sx={{ borderColor: TOKENS.magenta, color: TOKENS.magenta, borderRadius: 120, px: 3, fontFamily: "Zen Maru Gothic", fontWeight: 900 }}
                    >
                        {t('Customize')}
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => dispatch(cookiesRejectNonEssential())}
                        sx={{ borderColor: TOKENS.magenta, color: TOKENS.magenta, borderRadius: 120, px: 3, fontFamily: "Zen Maru Gothic", fontWeight: 900 }}
                    >
                        {t('Reject')}
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
}
